__turbopack_context__.v({
  "stickyFooter": "H2GytG_stickyFooter",
});
